export const ALL_OPTION = {id: 'all', label: '전체'};

export const MEDALS = ['🥇', '🥈', '🥉'];

export const FULL_DATE_FORMAT = 'YYYY.MM.DD';
